import React from "react";
import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Button,
  Box,
  Tooltip,
  Typography,
  Chip,
} from "@mui/material";
import { DragIndicator } from "@mui/icons-material";
import playlist from "../../img/default-image.png";
import GetMoodGenreLanguage from "../../_helpers/reusablefunctions/getMoodGenreLanguage";

const CardComponent = ({
  data,
  activeLabel,
  openDetails,
  trendingplaylist,
  provided,
  genre,
  mood,
  language,
  name,
  alt,
  image,
  title,
  type,
}) => {
  const genreMoodLanguageConst = (label, value) => {
    return (
      <Box className="d-flex align-items-center gap-2">
        <Typography variant="body2">
          <strong>{label}:</strong>
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            marginTop: 1,
          }}
        >
          {value ? (
            <Chip
              key={value?.id}
              label={value?.genre || value?.mood || value?.language}
              sx={{ backgroundColor: "#E6EEEF" }}
            />
          ) : (
            "-"
          )}
        </Box>
      </Box>
    );
  };

  return (
    <Card
      className="h-100 position-relative"
      role="box"
      tabIndex="0"
      ref={provided?.innerRef}
      {...provided?.draggableProps}
    >
      {activeLabel === "trending" && (
        <Box className="text-center" {...provided.dragHandleProps}>
          <DragIndicator />
        </Box>
      )}

      <CardMedia
        onClick={() => openDetails(data)}
        component="img"
        alt={alt}
        image={image}
        sx={{
          aspectRatio: '1 / 1',
          width: '100%',
          objectFit: 'contain',
          cursor: 'pointer'
        }}
      />
      <CardContent className="pb-5">
        <Tooltip title={title} placement="top" arrow>
          <Typography variant="body2" className="text-truncate">
            <strong>Name:</strong> {name}
          </Typography>
        </Tooltip>
        {Array?.isArray(genre) ||
          Array?.isArray(mood) ||
          Array?.isArray(language) ? (
          activeLabel != "artist" ? (
            <Box>
              <GetMoodGenreLanguage label="Genre" items={genre || []} />
              <GetMoodGenreLanguage label="Mood" items={mood || []} />
              <GetMoodGenreLanguage label="Language" items={language || []} />
            </Box>
          ) : null
        ) : (
          activeLabel != "artist" ? (
            <Box>
              {genreMoodLanguageConst("Genre", genre)}
              {genreMoodLanguageConst("Mood", mood)}
              {genreMoodLanguageConst("Language", language)}
            </Box>
          ) : null
        )}
      </CardContent>
      <CardActions className="position-absolute bottom-0">
        {activeLabel != "artist" ? (
          <Box display={"flex"} justifyContent={"space-between"} width={"100%"}>
            <Button
              variant="text"
              disabled={type === "trending" && activeLabel !== "trending"}
              sx={{ fontSize: "11px" }}
              onClick={() => trendingplaylist(data)}
            >
              {activeLabel !== "trending"
                ? "Mark it trending"
                : "Remove from trending"}
            </Button>
          </Box>
        ) : null}
      </CardActions>
    </Card>
  );
};

export default CardComponent;
